import { render, staticRenderFns } from "./New-User.vue?vue&type=template&id=a5038c6c"
import script from "./New-User.vue?vue&type=script&lang=js"
export * from "./New-User.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports